module.exports = __webpack_public_path__ + "static/media/main-res.4a15c477.jpg";